const NavbarImg = ({ className }: { className?: string }) => (
  <img src="/ctb-logo-crop.svg" alt="CTB" className={className} />
);

export default NavbarImg;
  